var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 80,
    viewBox: "0 0 71 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 80C58.6878 80 71 67.9677 71 53.125C71 38.2823 58.6878 26.25 43.5 26.25C28.3122 26.25 16 38.2823 16 53.125C16 67.9677 28.3122 80 43.5 80Z",
    fill: "#FFEAE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6364 14.9965V7.49843C44.6364 4.0468 41.7641 1.25 38.2193 1.25H7.41711C3.8723 1.25 1 4.0468 1 7.49843V72.482C1 75.9337 3.8723 78.7305 7.41711 78.7305H38.2193C41.7641 78.7305 44.6364 75.9337 44.6364 72.482V52.4871",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0374 18.7456L36.9358 33.7418L13.8342 18.7456",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0374 48.738H24.1016L13.8342 58.7355V18.7456H60.0374V48.738Z",
    stroke: "#E53B34",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5188 41.2399H33.0856",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6523 41.2399H38.2192",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7861 41.2399H43.353",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5028 52.4871V68.733H6.13379V8.74811H39.5028V14.9965",
    stroke: "#374354",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6846 73.7318H27.9519",
    stroke: "#374354",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPhoneIcon);
export default __webpack_public_path__ + "static/media/confirm-phone-icon.d35043c83679a55eaa230a3579be2328.svg";
export { ForwardRef as ReactComponent };